import React from 'react';
import { Table, Empty, Button, Input, Form, Select, Tag } from 'antd';
const { Option } = Select;

export default function Referencias(props) {
    return (
        <div>
            <Table
                style={{ overflowX: 'auto' }}
                className={'table-referencia'}
                size="small"
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: '50px',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Button
                                        type="danger"
                                        icon="delete"
                                        size={"small"}
                                        onClick={() => props.onRemove(value)}
                                    />
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Nombre de Garante',
                        dataIndex: 'idGarante',
                        key: 'idGarante',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrGarante[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Garante"}
                                            optionFilterProp="children"
                                        >
                                            {props.garantes.map(item => ( 
                                                <Option value={item.idEntidad} key={item.idEntidad}> <Tag color='green' >{item.tipoDocumentoNombre}</Tag>{`${item.numeroDocumento} - ${item.nombre}`}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                    {
                        title: '',
                        dataIndex: 'flagInterno',
                        className: 'hide',
                        key: 'flagInterno',
                        render: (value, row) => {
                            return (
                                <div>
                                    {props.onGetFieldDecorator(`arrFlagInterno[${row.identifier}]`, { initialValue: value })(
                                        <Input />
                                    )}
                                </div>
                            );
                        }
                    }
                ]}
            />
        </div>
    );
}